// ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
// ░░░░░░░░▄▀░█▀▄░█▀▀░█▀▀░█░█░█░░░█▀█░█▀▄░░░░░█░░░█▀█░█░█░█▀█░█░█░▀█▀░▀▄░░░░░░░░
// ░░░░░░░▀▄░░█▀▄░█▀▀░█░█░█░█░█░░░█▀█░█▀▄░▀▀▀░█░░░█▀█░░█░░█░█░█░█░░█░░░▄▀░░░░░░░
// ░░░░░░░░░▀░▀░▀░▀▀▀░▀▀▀░▀▀▀░▀▀▀░▀░▀░▀░▀░░░░░▀▀▀░▀░▀░░▀░░▀▀▀░▀▀▀░░▀░░▀░░░░░░░░░
// ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃  *  Copyright (c) 2026, the Regular Layout Authors. This file is part  *  ┃
// ┃  *  of the Regular Layout library, distributed under the terms of the  *  ┃
// ┃  *  [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). *  ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

import type { Layout, LayoutPathTraversal } from "../core/types.ts";

/**
 * Calculates the index path for a panel with the given name.
 *
 * Traverses the layout tree to find the named panel and returns the
 * index path describing its position in the tree.
 *
 * @param name - The name of the panel to find.
 * @param layout - The layout tree to search.
 * @returns The panel's index path if found, `null` otherwise.
 */
export function calculate_path(name: string, layout: Layout): number[] | null {
	return calculate_path_recursive(name, layout, []);
}

function calculate_path_recursive(
	name: string,
	panel: Layout,
	path: LayoutPathTraversal,
): number[] | null {
	if (panel.type === "tab-layout") {
		if (!panel.tabs.includes(name)) {
			return null;
		}

		return path;
	}

	for (let i = 0; i < panel.children.length; i++) {
		const result = calculate_path_recursive(name, panel.children[i], [
			...path,
			i,
		]);

		if (result) {
			return result;
		}
	}

	return null;
}
